import styled from 'styled-components';

const Section = styled.div`
  padding: 24px 32px;

  ${({ noPadding }) => noPadding && 'padding: 0;'}
`;

export default Section;
